/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-05 22:03:17
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-24 19:32:28
 * @FilePath: /wemeet-web-activity/src/pages/payend/component/statusTip.tsx
 * @Description: 购买状态
 */
import React, { memo } from 'react';
import succesIcon from "./imgs/success.svg";
import errIcon from "./imgs/pay-warn.svg";
import failIcon from "./imgs/fail.svg";
import classnames from 'classnames';
import "./index.scss";
const succInfo = {
  icon: succesIcon,
  title: '报名成功',
  desc: ''
};
const errInfo = {
  icon: errIcon,
  title: '报名失败',
  desc: '抢票的人太多啦，请再试试吧'
};
const failInfo = {
  icon: failIcon,
  title: '支付失败',
  desc: '请重新报名'
};
const approvalInfo = {
  icon: succesIcon,
  title: '提交成功，审批中',
  desc: '审批结果和门票信息将会发送到您的手机号'
};
const infoMap = {
  succ: succInfo,
  err: errInfo,
  fail: failInfo,
  approval: approvalInfo
};
const StatusTip = ({
  tip,
  className,
  desc
}) => {
  const info = infoMap[tip];
  return /*#__PURE__*/React.createElement("div", {
    className: classnames({
      'top-success': true,
      [className || '']: true
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-type"
  }, /*#__PURE__*/React.createElement("img", {
    src: info.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: "tit"
  }, info.title)), desc && /*#__PURE__*/React.createElement("div", {
    className: "desc"
  }, desc), info.desc && /*#__PURE__*/React.createElement("div", {
    className: "desc"
  }, info.desc));
};
export default /*#__PURE__*/memo(StatusTip);